import { NotificationSource } from "./notificationSource";
export interface TransportOrderNotificationListItemDto {
    id: string;
    message: number;
    state: number;
    orderState: number;
    source: NotificationSource;
    createdDateTime: string;
    modifiedDateTime: string;
    employeeId: string;
    createdEmployeeId: string;
    modifiedEmployeeId: string;
}

export enum TransportOrderNotificationState {
    Created = 0,
    Notified = 1,
    Confirmed = 2
}
